import NumberFormat from 'react-number-format'
import React from 'react'
import { getText } from '../../../internal/TextLabels'

const CurrencyFormat = ({ value, hideDecimalIfInteger = false }) => {
  const isInteger = value % 1 === 0

  return (
    (value || value === 0) && (
      <NumberFormat
        value={value}
        displayType="text"
        thousandSeparator=" "
        decimalSeparator=","
        decimalScale={isInteger && hideDecimalIfInteger ? 0 : 2}
        fixedDecimalScale
        renderText={formattedValue =>
          getText('default.currency', formattedValue)
        }
      />
    )
  )
}

export default CurrencyFormat
